export default __webpack_public_path__ + "static/media/analytics-darker.5ea37444.jpg";